import { Ability, AbilityBuilder } from '@casl/ability';

export function defineAbilityFor(permissions, userOrgId) {
  const { can, build } = new AbilityBuilder(Ability);

  for (const perm of permissions) {
    const { action, resource, access } = perm;

    if (resource === '*') {
      if (access === 'any') {
        can(action, 'all');
      } else {
        can(action, 'all', { organizationId: userOrgId });
      }
      if (action === 'manage') {
        for (const a of ['create', 'read', 'update', 'delete']) {
          if (access === 'any') {
            can(a, 'all');
          } else {
            can(a, 'all', { organizationId: userOrgId });
          }
        }
      }
      continue;
    }

    if (access === 'any') {
      can(action, resource);
    } else {
      can(action, resource, { organizationId: userOrgId });
    }

    if (action === 'manage') {
      for (const a of ['create', 'read', 'update', 'delete']) {
        if (access === 'any') {
          can(a, resource);
        } else {
          can(a, resource, { organizationId: userOrgId });
        }
      }
    }
  }

  return build();
}

export const defaultAbility = new Ability([]);
